import React, { useEffect } from 'react';

import { Box, PageHeader } from 'components';

import { useNavigate, useSelector, useTranslation } from 'third-party';

import { userPaymentListUrl } from 'constants/url';

import { appSelectors } from 'selectors';

export const Dashboard = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const userInfoPending = useSelector(appSelectors.userInfoPending);
  const user = useSelector(appSelectors.user);

  useEffect(() => {
    if (!userInfoPending && user) {
      navigate(userPaymentListUrl());
    }
  }, [navigate, user, userInfoPending]);

  return (
    <Box minWidth="30rem">
      <PageHeader
        header={t('common.empty.header')}
        subHeader={t('common.empty.subHeader')}
      />
    </Box>
  );
};
